import {
  ArrayField,
  ChipField,
  DateField,
  SingleFieldList,
  TextField,
} from "react-admin";
import React, { Fragment } from "react";

import Actions from "./Actions";
import Card from "./Card";
import EditButton from "./buttons/EditButton";
import Location from "./Location";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import TreeLinkField from "./fields/TreeLinkField";
import TypeField from "./fields/TypeField";
import { get } from "lodash";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

let rowClass;

const Grid = (props) => (
  <Fragment>
    <Location
      loading={get(props, "loading")}
      id={get(props, "filterValues.location_id")}
    />
    <ResponsiveGridWithWebsocket
      {...props}
      rowBreakpoint="sm"
      cardContent={<Card />}
      rowClasses={rowClass}
      target="location"
    >
      <TextField source="id" />
      <TypeField source="type" />
      <TreeLinkField source="name">
        <TextField />
      </TreeLinkField>
      <ArrayField source="groups" sortable={false}>
        <SingleFieldList linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <DateField source="modified" showTime />
      <EditButton />
    </ResponsiveGridWithWebsocket>
  </Fragment>
);
const List = (props) => {
  const { location: highlightedLocationIds = [] } = useRowHighlightTracking();

  // cancella da localStorage in 'locationList' quando la scheda viene chiusa - start
  const search = window.location.hash.split("?")[1] || "";

  let locationId;
  try {
    const params = new URLSearchParams(search);
    const filter = JSON.parse(params.get("filter"));
    locationId = filter?.location_id?.toString();
  } catch {
    locationId = undefined;
  }

  useManageOpenEditTabs("locationList", locationId);
  // cancella da localStorage in 'locationList' quando la scheda viene chiusa - start

  rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedLocationIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      actions={<Actions />}
      type="table"
      split
      key={highlightedLocationIds.join(",")}
    >
      <Grid />
    </ResponsiveList>
  );
};

export default List;
